import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getDailyPhrasesList } from '../../../api';

const DailyPhraseList = () => {
    const navigate = useNavigate();
    const [phrases, setPhrases] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            navigate('/');
            return;
        }

        fetchPhrases();
    }, [navigate]);

    const fetchPhrases = async () => {
        try {
            setLoading(true);
            setError('');
            const data = await getDailyPhrasesList();
            setPhrases(data || []);
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to fetch daily phrases.');
            console.error('Error fetching daily phrases:', err);
        } finally {
            setLoading(false);
        }
    };

    const token = localStorage.getItem('token');
    if (!token) {
        return null;
    }

    return (
        <div style={{
            minHeight: '100vh',
            background: '#ccdff5',
            padding: '40px 20px'
        }}>
            <div style={{
                maxWidth: '1400px',
                margin: '0 auto',
                background: '#F6F6F6',
                borderRadius: '20px',
                padding: '40px',
                boxShadow: '0 4px 24px rgba(44, 62, 80, 0.08)'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '30px'
                }}>
                    <h1 style={{
                        color: '#3c5a5d',
                        margin: 0,
                        fontSize: '2.5rem'
                    }}>
                        Daily Phrases
                    </h1>
                </div>

                {error && (
                    <div style={{
                        color: '#dc2626',
                        marginBottom: '20px',
                        padding: '12px',
                        background: '#fee2e2',
                        borderRadius: '8px',
                        fontSize: '14px'
                    }}>
                        {error}
                    </div>
                )}

                {loading ? (
                    <div style={{
                        textAlign: 'center',
                        padding: '60px 20px',
                        color: '#707F81',
                        fontSize: '1.1rem'
                    }}>
                        Loading phrases...
                    </div>
                ) : phrases.length === 0 ? (
                    <div style={{
                        textAlign: 'center',
                        padding: '60px 20px',
                        color: '#707F81',
                        fontSize: '1.1rem'
                    }}>
                        No daily phrases found.
                    </div>
                ) : (
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
                        gap: '24px'
                    }}>
                        {phrases.map((phrase, index) => (
                            <div
                                key={phrase.id || index}
                                onClick={() => navigate(`/daily-phrases/${phrase.id}`)}
                                style={{
                                    background: '#e5eff8',
                                    borderRadius: '16px',
                                    padding: '24px',
                                    border: '1px solid #cfd8dc',
                                    boxShadow: '0 2px 12px rgba(44, 62, 80, 0.08)',
                                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                    cursor: 'pointer'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                    e.currentTarget.style.boxShadow = '0 8px 30px rgba(0, 0, 0, 0.1)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 2px 12px rgba(44, 62, 80, 0.08)';
                                }}
                            >
                                <h3 style={{
                                    color: '#3c5a5d',
                                    marginBottom: '12px',
                                    fontSize: '1.5rem',
                                    fontWeight: '600'
                                }}>
                                    {phrase.phrase}
                                </h3>
                                <p style={{
                                    color: '#5b7173',
                                    fontSize: '1rem',
                                    marginBottom: '16px'
                                }}>
                                    {phrase.translation}
                                </p>
                                <div style={{
                                    display: 'flex',
                                    gap: '8px',
                                    flexWrap: 'wrap'
                                }}>
                                    {phrase.date && (
                                        <span style={{
                                            background: '#dbeafe',
                                            color: '#1e40af',
                                            padding: '4px 10px',
                                            borderRadius: '16px',
                                            fontSize: '0.85rem',
                                            fontWeight: '600'
                                        }}>
                                            {phrase.date}
                                        </span>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default DailyPhraseList;
